// Dependencies
import * as React from 'react';
// Styled
import { SvgElement } from './IconStyle';
// Props
import { IconProps, defaultProps } from './IconProps';

const LogoMono = (props:IconProps) => {
  const componentProps = { ...defaultProps, ...props };
  const {
    fillColor,
    height,
    onClick,
    width,
  } = componentProps;

  const handleClick = () => {
    if (typeof onClick === 'function') {
      onClick();
    }
  };

  return (
    <SvgElement
      height={ height }
      onClick={ handleClick }
      preserveAspectRatio="none"
      viewBox="0 0 32 32"
      width={ width }
    >
      <g>
        <path
          d="
            M21.4470367,29.5506935h6.777792
            c0.5256042,0,0.953125-0.4236431,0.953125-0.9491749
            c0-0.3295116-0.1686573-0.6197605-0.4196682-0.7883949
            c-0.0039272-0.0039253-0.0078526-0.0078526-0.0117798-0.0078526
            c-2.1572876-1.2512035-5.0127373-3.0869274-7.3700695-5.2088795
            c-0.0549183-0.0470181-0.1059093-0.0941315-0.1569023-0.1412468
            c-0.2235756-0.1921902-0.431448-0.3883076-0.6354179-0.584425
            c-0.1294441-0.1176891-0.2510357-0.2392082-0.3726273-0.3568974
            c-0.1804123-0.1804123-0.3569221-0.3569946-0.521677-0.5333843
            c-0.4471283-0.4746838-0.8472157-0.9414196-1.2002354-1.4003029
            c-0.0431404-0.054966-0.0862808-0.1137638-0.1294193-0.1726551
            c-0.0863037-0.1137638-0.1686592-0.2313576-0.2471104-0.3411942
            c-0.039238-0.0588932-0.0784512-0.1137638-0.1137619-0.1725597
            c-0.0470676-0.0628185-0.0862808-0.1216164-0.1215916-0.1805096
            c-0.0548954-0.0823536-0.1019611-0.16078-0.1529541-0.2392082
            c-0.050993-0.0862808-0.101984-0.1725597-0.152977-0.2549133
            c-0.1451244-0.2510834-0.2706432-0.5020714-0.3883076-0.7492294
            c-0.0157051-0.0352402-0.0470657-0.0587959-0.0863037-0.0587959
            c-0.050993,0-0.0902061,0.0430908-0.0902061,0.0941315v7.5544319
            C17.0069447,25.0596333,16.602932,29.5506935,21.4470367,29.5506935z
          "
          fill={ fillColor }
        />
        <path
          d="
            M10.5529633,29.5506935H3.7751718
            c-0.5256042,0-0.953126-0.4236431-0.953126-0.9491749
            c0-0.3295116,0.1686578-0.6197605,0.4196694-0.7883949
            c0.003926-0.0039253,0.0078523-0.0078526,0.0117786-0.0078526
            c2.1572871-1.2512035,5.0127387-3.0869274,7.370069-5.2088795
            c0.0549183-0.0470181,0.1059113-0.0941315,0.1569033-0.1412468
            c0.2235765-0.1921902,0.431448-0.3883076,0.635417-0.584425
            c0.1294441-0.1176891,0.2510357-0.2392082,0.3726273-0.3568974
            c0.1804123-0.1804123,0.3569221-0.3569946,0.521678-0.5333843
            c0.4471283-0.4746838,0.8472147-0.9414196,1.2002354-1.4003029
            c0.0431404-0.054966,0.0862799-0.1137638,0.1294203-0.1726551
            c0.0863037-0.1137638,0.1686573-0.2313576,0.2471094-0.3411942
            c0.039237-0.0588932,0.0784512-0.1137638,0.1137629-0.1725597
            c0.0470657-0.0628185,0.0862799-0.1216164,0.1215916-0.1805096
            c0.0548944-0.0823536,0.1019611-0.16078,0.1529531-0.2392082
            c0.050992-0.0862808,0.101985-0.1725597,0.152977-0.2549133
            c0.1451244-0.2510834,0.2706423-0.5020714,0.3883076-0.7492294
            c0.0157051-0.0352402,0.0470667-0.0587959,0.0863047-0.0587959
            c0.050992,0,0.0902061,0.0430908,0.0902061,0.0941315v7.5544319
            C14.9930563,25.0596333,15.397068,29.5506935,10.5529633,29.5506935z
          "
          fill={ fillColor }
        />
        <circle
          cx="16"
          cy="6.5986114"
          fill={ fillColor }
          r="4.1493053"
        />
        <path
          d="
            M14.8084211,14.7536373c0-0.8827085-0.4854612-1.6530142-1.2023754-2.0620899
            l-0.0009623-0.0024986l-0.0160942-0.007863
            C13.509944,12.6369629,1.4573027,6.753695,1.4573027,6.753695
            L1.299578,6.6748323H1.2958182
            C1.1943976,6.6372585,1.0816978,6.6147227,0.9614787,6.6147227
            C0.4319088,6.6147227,0,7.0429177,0,7.5725336v7.3280306
            c0,1.4836445,0.7736762,2.7832451,1.9380878,3.5231743
            c0.129481,0.0832195,0.3745502,0.2127914,0.3745502,0.2127914
            l5.0849047,2.4601688c0,0,0.6003957,0.2737141,1.1840806,0.2737141
            c0.5166159,0,1.0456839-0.235033,1.0494432-0.2387924
            c0.4474421-0.2175522,0.7919674-0.4655094,0.7919674-0.4655094
            c1.6073828-1.2009354,3.0689993-2.7853756,4.0527906-4.6612682
            c0.0299854-0.0600863,0.056304-0.1239328,0.0826216-0.184042
            c0.0450249-0.0939016,0.0863819-0.1878023,0.1239338-0.2892008
            v-0.0037594l-0.002614-0.0069466
            C14.7617464,15.280158,14.8084211,15.022686,14.8084211,14.7536373z
          "
          fill={ fillColor }
        />
        <path
          d="
            M17.1915779,14.7536373
            c0-0.8827085,0.4854622-1.6530142,1.2023754-2.0620899
            l0.0009632-0.0024986l0.0160942-0.007863
            C18.490057,12.6369629,30.5426979,6.753695,30.5426979,6.753695
            l0.1577244-0.0788627h0.0037594
            c0.1014214-0.0375738,0.2141209-0.0601096,0.3343391-0.0601096
            C31.5680904,6.6147227,32,7.0429177,32,7.5725336v7.3280306
            c0,1.4836445-0.7736759,2.7832451-1.9380875,3.5231743
            c-0.1294804,0.0832195-0.3745499,0.2127914-0.3745499,0.2127914
            l-5.0849056,2.4601688c0,0-0.6003952,0.2737141-1.1840801,0.2737141
            c-0.5166168,0-1.0456829-0.235033-1.0494423-0.2387924
            c-0.447443-0.2175522-0.7919674-0.4655094-0.7919674-0.4655094
            c-1.6073837-1.2009354-3.0690002-2.7853756-4.0527916-4.6612682
            c-0.0299854-0.0600863-0.056303-0.1239328-0.0826225-0.184042
            c-0.0450249-0.0939016-0.0863819-0.1878023-0.1239319-0.2892008
            v-0.0037594l0.0026131-0.0069466
            C17.2382545,15.280158,17.1915779,15.022686,17.1915779,14.7536373z
          "
          fill={ fillColor }
        />
      </g>
    </SvgElement>
  );
};

export { LogoMono };
